import UrlEndpoints from "../client/UrlEndpoints";
import axios from 'axios';
import { 
    TRANSLATE_LOADING_ACTION, 
    TRANSLATE_GET_ROLES_SUCCESS_ACTION, 
    TRANSLATE_GET_ROLES_ERROR_ACTION,
    TRANSLATE_DELETE_ROLE_SUCCESS_ACTION, 
    TRANSLATE_DELETE_ROLE_ERROR_ACTION,
    TRANSLATE_POST_ROLE_SUCCESS_ACTION,
    TRANSLATE_POST_ROLE_ERROR_ACTION,
    TRANSLATE_PATCH_ROLE_SUCCESS_ACTION,
    TRANSLATE_PATCH_ROLE_ERROR_ACTION,
    TRANSLATE_GET_ROLE_SUCCESS_ACTION,
    TRANSLATE_GET_ROLE_ERROR_ACTION
} from '../translates/Translates';
import {getRequestConfig} from '../client/helpers/Helper';

export const SET_LOADING_GET_ROLES = 'SET_LOADING_GET_ROLES';
export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_ERROR = 'GET_ROLES_ERROR';

export const SET_LOADING_DELETE_ROLE = 'SET_LOADING_DELETE_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_ERROR = 'DELETE_ROLE_ERROR';

export const SET_LOADING_POST_ROLE = 'SET_LOADING_POST_ROLE';
export const POST_ROLE = 'POST_ROLE';
export const POST_ROLE_SUCCESS = 'POST_ROLE_SUCCESS';
export const POST_ROLE_ERROR = 'POST_ROLE_ERROR';

export const SET_LOADING_GET_ROLE = 'SET_LOADING_GET_ROLE';
export const GET_ROLE = 'GET_ROLE';
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS';
export const GET_ROLE_ERROR = 'GET_ROLE_ERROR';

export const SET_LOADING_PATCH_ROLE = 'SET_LOADING_PATCH_ROLE';
export const PATCH_ROLE = 'PATCH_ROLE';
export const PATCH_ROLE_SUCCESS = 'PATCH_ROLE_SUCCESS';
export const PATCH_ROLE_ERROR = 'PATCH_ROLE_ERROR';

const setLoadingGetRoles = () => {
    return {
        type: SET_LOADING_GET_ROLES,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const getRoles = () => {
    let url = UrlEndpoints.GET_ROLES;
    let request_url = UrlEndpoints.getUrlEndpoint(url);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: GET_ROLES,
        payload: axios.get(request_url, request_config)
    }
}

const getRolesSuccess = () => {
    return {
        type: GET_ROLES_SUCCESS,
        payload: TRANSLATE_GET_ROLES_SUCCESS_ACTION
    }
}

const getRolesError = () => {
    return {
        type: GET_ROLES_ERROR,
        payload: TRANSLATE_GET_ROLES_ERROR_ACTION
    }
}

const setLoadingGetRole = () => {
    return {
        type: SET_LOADING_GET_ROLE,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const getRole = (id) => {
    let url = UrlEndpoints.GET_ROLE;
    let request_url = UrlEndpoints.getUrlEndpoint(url, id);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: GET_ROLE,
        payload: axios.get(request_url, request_config)
    }
}

const getRoleSuccess = () => {
    return {
        type: GET_ROLE_SUCCESS,
        payload: TRANSLATE_GET_ROLE_SUCCESS_ACTION
    }
}

const getRoleError = () => {
    return {
        type: GET_ROLE_ERROR,
        payload: TRANSLATE_GET_ROLE_ERROR_ACTION
    }
}

const setLoadingDeleteRole = () => {
    return {
        type: SET_LOADING_DELETE_ROLE,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const deleteRole = (id) => {
    let url = UrlEndpoints.DELETE_ROLE;
    let request_url = UrlEndpoints.getUrlEndpoint(url, id);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: DELETE_ROLE,
        payload: axios.delete(request_url, request_config)
    }
}

const deleteRoleSuccess = () => {
    return {
        type: DELETE_ROLE_SUCCESS,
        payload: TRANSLATE_DELETE_ROLE_SUCCESS_ACTION
    }
}

const deleteRoleError = () => {
    return {
        type: DELETE_ROLE_ERROR,
        payload: TRANSLATE_DELETE_ROLE_ERROR_ACTION
    }
}

const setLoadingPostRole = () => {
    return {
        type: SET_LOADING_POST_ROLE,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const postRole = (data) => {
    let url = UrlEndpoints.POST_ROLE;
    let request_url = UrlEndpoints.getUrlEndpoint(url);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: POST_ROLE,
        payload: axios.post(request_url, data, request_config)
    }
}

const postRoleSuccess = () => {
    return {
        type: POST_ROLE_SUCCESS,
        payload: TRANSLATE_POST_ROLE_SUCCESS_ACTION
    }
}

const postRoleError = () => {
    return {
        type: POST_ROLE_ERROR,
        payload: TRANSLATE_POST_ROLE_ERROR_ACTION
    }
}

const setLoadingPatchRole = () => {
    return {
        type: SET_LOADING_PATCH_ROLE,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const patchRole = (data) => {
    let url = UrlEndpoints.PATCH_ROLE;
    let request_url = UrlEndpoints.getUrlEndpoint(url, data.id);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: PATCH_ROLE,
        payload: axios.patch(request_url, data, request_config)
    }
}

const patchRoleSuccess = () => {
    return {
        type: PATCH_ROLE_SUCCESS,
        payload: TRANSLATE_PATCH_ROLE_SUCCESS_ACTION
    }
}

const patchRoleError = () => {
    return {
        type: PATCH_ROLE_ERROR,
        payload: TRANSLATE_PATCH_ROLE_ERROR_ACTION
    }
}

export {
    setLoadingGetRoles,
    getRoles,
    getRolesSuccess,
    getRolesError,
    setLoadingDeleteRole,
    deleteRole,
    deleteRoleSuccess,
    deleteRoleError,
    setLoadingPostRole,
    postRole,
    postRoleSuccess,
    postRoleError,
    setLoadingGetRole,
    getRole,
    getRoleSuccess,
    getRoleError,
    setLoadingPatchRole,
    patchRole,
    patchRoleSuccess,
    patchRoleError
}
